import React from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { FadeInArray } from "source/app/presentation/Shared/Animation/FadeInArray";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import styled from "styled-components";
import { ISoundMasterMenuState } from "source/app/presentation/Header/Tools/Sound/Master/ISoundMasterMenuState";
import SoundManager from "source/app/services/Sound/SoundManager";
import Tool from "source/app/presentation/Header/Tools/Tool";
import { LevelAnalyzer } from "../LevelAnalyzer";

export default class SoundMasterMenu extends React.Component<
    {},
    ISoundMasterMenuState
> {
    dropdownRef: React.RefObject<HTMLDivElement>;

    constructor(props: {}) {
        super(props);

        this.state = {
            showMenu: false,
            isPlaying: true,
        };

        this.dropdownRef = React.createRef();
    }

    async componentDidMount() {
        State.ShareClass(ESharedComponent.SoundMasterMenu, this);
        this.handleMenuToggling();
    }

    componentDidUpdate(
        prevProps: Readonly<{}>,
        prevState: Readonly<ISoundMasterMenuState>,
        snapshot?: any
    ): void {
        State.ShareClass(ESharedComponent.SoundMasterMenu, this);
    }

    handleMenuToggling() {
        const handleClickOutside = (event: any) => {
            if (
                this.dropdownRef !== null &&
                this.dropdownRef.current !== null &&
                !this.dropdownRef.current.contains(event.target)
            ) {
                this.setState({ ...this.state, showMenu: false });
            }
        };

        // Attach the listener to the document
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup the listener when the component unmounts
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }

    render() {
        if (IsMobileDevice()) {
            return null;
        }

        const subMenuItems = [
            <SubMenuItemWithBorder>
                <Tool
                    options={{
                        onClick: () => {
                            SoundManager.ToggleEnvironment();
                            this.setState({ isPlaying: !this.state.isPlaying });
                        },
                        classes: !this.state.isPlaying
                            ? "glyphicon-play orange"
                            : "glyphicon-stop",
                    }}
                />
            </SubMenuItemWithBorder>,
            <SubMenuItem>
                <LevelAnalyzer />
            </SubMenuItem>,
        ];

        return (
            <Container ref={this.dropdownRef}>
                <Hyperlink
                    whenClicked={() =>
                        this.setState({
                            ...this.state,
                            showMenu: !this.state.showMenu,
                        })
                    }
                    classes={StyleClassAuto({
                        color: this.state.isPlaying
                            ? `rgb(208, 208, 208)`
                            : `orange`,
                        opacity: this.state.isPlaying ? 1.0 : 0.5,
                        transition: `all 0.5s ease !important`,
                    })}
                >
                    <Glyphicon
                        icon={
                            this.state.isPlaying
                                ? EGlyphicon["volume-up"]
                                : EGlyphicon["volume-down"]
                        }
                    />
                </Hyperlink>
                <div
                    className={GetDropDownContentStyleClass(
                        this.state.showMenu
                    )}
                >
                    <FadeInArray
                        label=""
                        render={(item) => item}
                        array={subMenuItems}
                        itemDelayMs={50}
                    />
                </div>
            </Container>
        );
    }
}

const Container = styled.div`
    position: relative;
    display: inline-block;
    margin: 0px 5px;
`;

const GetDropDownContentStyleClass = (show: boolean) =>
    StyleClassAuto({
        display: show ? "flex" : "none",
        flexDirection: "column",
        position: "absolute",
        minWidth: "200px",
        boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
        padding: "12px 16px",
        zIndex: 1,
        right: 0,
        background: "#2e2e2e57",
        borderRadius: "4px",
    });

const SubMenuItem = styled.div`
    padding: 5px;
`;

const SubMenuItemWithBorder = styled(SubMenuItem)`
    border-radius: 3px;
    border: 1px dotted #c0c0c017;
    &:hover {
        border: 1px solid #c0c0c070;
    }
`;
